module.exports = __webpack_public_path__ + "static/media/38-2.f7c5d8ab.mp3";